import { useParams } from "react-router-dom";
import PreviewCommonComponent from "../MoveAction/PreviewAndReview/Preview/Components/PreviewCommonComponent";
import useItemCatTypeUpdate from "./useItemCatTypeUpdate";

const PreviewItemCatTypeUpdate = () => {
  const { audit_trail_id } = useParams();

  const previewData = useItemCatTypeUpdate(audit_trail_id);

  if (previewData.loading || previewData.snapshotLoading) return <div>Loading...</div>;
  if (previewData.error || previewData.snapshotError) return <div>Error: {previewData.error || previewData.snapshotError}</div>;

  return <>
    <PreviewCommonComponent previewData={previewData} audit_trail_id={audit_trail_id} />
  </>
};

export default PreviewItemCatTypeUpdate;